module.exports = __webpack_public_path__ + "img/authority.373e6036.png";